import { OnTimeUpdate } from './types';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

export type TimeUpdateMessageData = {
  type: 'timeupdate';
  millis: number;
};

export type UseTimeUpdateMessagingProps = {
  iframe?: HTMLIFrameElement | null;
  onTimeUpdate?: OnTimeUpdate;
};

export default function useTimeUpdateMessaging(
  props?: UseTimeUpdateMessagingProps,
) {
  const { iframe, onTimeUpdate } = props ?? {};

  useMessageHandler<TimeUpdateMessageData>(
    e => {
      if (e.data.type === 'timeupdate') {
        onTimeUpdate?.(e.data.millis);
      }
    },
    { iframe },
  );
}
